var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M7 .778a6.222 6.222 0 110 12.444A6.222 6.222 0 017 .778zM5.33 4.172l-.129.002c-1.083.058-1.915.994-1.859 2.092a3.531 3.531 0 00.744 2.416.742.742 0 01.005.506 13.21 13.21 0 00-1.366.578A5.087 5.087 0 007 12.091c.713 0 1.391-.147 2.008-.411a.775.775 0 00.07-.552 2.41 2.41 0 00-.144-.445c-.298-.608-1.048-.979-2.407-1.486a.713.713 0 01-.017-.498 3.546 3.546 0 00.754-2.433A1.976 1.976 0 005.33 4.172zm4.246.566l-.125.002a1.814 1.814 0 00-1.448.862c.027.135.045.274.052.416l.003.072v.072l-.002.102.007.129c.012.492-.06.979-.211 1.44.116.394.306.765.563 1.092.03.08.045.165.043.25.51.284.839.575 1.071.95l.074.128.044.086c.073.15.137.344.197.59l.059.26a5.247 5.247 0 001.295-1.306l.144-.222c-.2-.083-.42-.168-.66-.257a.662.662 0 01-.016-.463 3.293 3.293 0 00.7-2.259 1.835 1.835 0 00-1.791-1.945z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default ForwardRef;